import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useEffect, useMemo, useState } from "react"
import { ActivityListItem } from "./types"
import { getStatus } from "../../../../../../../hooks/status"
import { useMenu } from "../utils"
import { CustomPaper } from "../../../../../../../components/CustomPaper"
import StatusComponent from "../../../../../../../components/status"
import { Settings } from "../../../../../../../components/settings"
import { CaptionKeyVertical } from "../../../../../../../components/detailKeyValue/keyCaption.index"
import { CustomeIconButton } from "../../../../../../../components/customeIconButton"
import { icons } from "../../../../../../../utils/icons"
import { useContextState } from "../../../../../../../hooks/theme"
import { Status, Types } from "../../../../../../../utils/enums"
import { getType } from "../../../utils/methods/getTypeActivity"
import { useStyles } from "./styles"
import { ActivityType } from "../../../utils/enums/activityType"
import CustomAccordion from "../../../../../../../components/accordion"
import { ActivityDetailList } from "../activityDetailList"
import { useEvidenceDownload } from "../../../../../../calendar/pages/detail/hooks"
import { DetailAndUploadOfEvidences } from "../../../../../../../components/detailAndUploadOfEvidences"
import { ViewEvidence } from "../../../../../../../components/detailAndUploadOfEvidences/enum"
import { Evidence } from "../../../../../../../service/reportFolio/response"
import { formatEvidencesToSendBody, formatEvidenceToUploadEvidence } from "../../../../../../../components/uploadEvidence/methods"
import { useUploadEvidence } from "../../../../../../../components/uploadEvidence/hooks"
import { GetEvidencePayload } from "../../shared/detailHeader/types"
import { SnackSimple } from "../../../../../../../components"
import { handleAllErrors } from "../../../../../../../utils/methods/handleErrors"
import { EvidenceActivityBody } from "../../../../../../../service/logbook/body/evidencesActivity"
import { loogbookServiceFetch } from "../../../../../../../utils/constants/callService"
import { useEvidences } from "../../../../../../../hooks/evidences/useEvidences"
import useGeolocation from "../../../../../../../hooks/localization"
import dayjs from "dayjs"
import { Constants } from "../../../../../../../utils/constants"

export const ActivityItem = ({ position, id, closeStore, timeZone, toggleExpand, endDate, isUserWithPermission, initDate, unityLocation, assignedBy, geofence, isTheUserAssigned, status, storeAndId, title, type, isVisible, visibility, typeActivity, isForcedClosure, menuOption, endExecution, startExecution, finishLocation, initLocation, closeMotive, evidences: evidencesData, evidenceConfig, assignData, expandParent, locationInitSiteName, endDateJs, startDateJs, scheduledVisitId, modelId, model }: ActivityListItem) => {
  const styles = useStyles()
  const navigate = useNavigate()
  const [latInit, lngInit] = initLocation?.split(',').map(String) ?? '0,0';
  const storePoint = { lat: latInit, lng: lngInit, locationInitSiteName: locationInitSiteName }
  const evidenceUpload = useUploadEvidence()
  const someIsRequired = evidenceUpload.someEvidenceIsRequired()
  const { evidences, existEvidences, manageData } = useEvidences({ evidencesResponse: evidencesData ?? [], manualVagetActivitieslue: true })
  const { colors } = useContextState()
  const { t } = useTranslation()
  const statusDetail = useMemo(() => getStatus(status, colors, t), [status])
  const isNoFinisf = status === Status.NOT_FINISHED ? true : false;
  const colorNoFinish = colors.color13
  const { error } = useGeolocation()
  const startDate = dayjs.utc(startDateJs).format(Constants.dayjsFormat3)
  const validateDate = startDateJs ? dayjs().isBefore(dayjs(startDate), 'seconds') : false
  const canFinish = status == Status.STARTED && !error;
  const canStart = status == Status.TO_BE_STARTED && !error && !validateDate;
  const { menu } = useMenu({ status, canFinish, canStart, canDelete: !!isUserWithPermission, geofence: geofence, locationOn: !error, isTheUserAssigned: isTheUserAssigned })

  const [view, setView] = useState<ViewEvidence>(ViewEvidence.DETAIL)
  const [snackbar, setSnackbar] = useState({
    open: false,
    type: Types.SUCCESS,
    message: '',
  })

  const { defaultEvidence, evidencesDrawer, evidencesRequiredAreLoad, setDeletedsEvidencesList, setEvidencesDrawer, setEvidencesRequiredAreLoad, } = evidenceUpload
  const showComponent = useMemo(() => status == Status.STARTED || existEvidences, [status, existEvidences])
  const rawEvidences = Object.values(evidences || {}).flat();
  const comments = rawEvidences
    .filter(e => e.type === 5 && e.name)
    .map(e => e.name as string);

  const flattenedEvidences: Evidence[] = [
    ...rawEvidences
      .filter(e => e.type !== 5)
      .map(e => ({
        url: e.src,
        originalname: e.originalName,
        evidenceTypeId: e.type,
      })),
    ...(comments.length > 0 ? [{ comments }] : [])
  ];

  const { disable, downloadEvidences, } = useEvidenceDownload('Evidencias de bitácora', flattenedEvidences);

  const validateCanUpload = () => {
    if (status == Status.STARTED) {
      if (isUserWithPermission) {
        setView(ViewEvidence.EDIT)
      } else {
        setView(ViewEvidence.DETAIL)
      }
      const response = formatEvidenceToUploadEvidence({ evidenceConfig: evidenceConfig?.evidence, evidencesDetail: evidences })
      defaultEvidence({ evidencesConfig: response, requireList: evidenceConfig?.requireList })
    }
  }

  const submitEvidences = async ({ evidences }: GetEvidencePayload) => {
    const thereAreSomeChange = evidenceUpload.hasAnyValueChanged()
    if (!thereAreSomeChange) {
      setSnackbar({ message: t('loogbook.snackbar.thereAreNotSomeChange'), open: true, type: Types.ERROR })
      return
    }
    if (!!thereAreSomeChange) {
      const convert = formatEvidencesToSendBody({ evidences })
      const [part1, part2] = id.split("-");
      const body: EvidenceActivityBody = {
        ...convert,
        id: part2
      }
      const response = await loogbookServiceFetch.evidencesActivity({ body })
      if (!response.errors) {
        evidenceUpload.deleteListOfFiles()
        setSnackbar({ message: t('loogbook.snackbar.evidenceActivity.success'), open: true, type: Types.SUCCESS })
        assignData()
        return
      }
      setSnackbar({ message: handleAllErrors(response?.errors?.[0]?.code, t, 'loogbook.snackbar.evidenceActivity.error'), open: true, type: Types.ERROR })
    }
  }

  const closeSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }))
  }

  useEffect(() => {
    manageData({ evidencesResponse: evidencesData })
    evidenceUpload.setShowRequireds(false)
    setEvidencesRequiredAreLoad(evidenceConfig?.requireList ?? {})
  }, [])

  useEffect(() => {
    if (evidences && Object.keys(evidences).length > 0) {
      const response = formatEvidenceToUploadEvidence({ evidenceConfig: evidenceConfig?.evidence, evidencesDetail: evidences })
      defaultEvidence({ evidencesConfig: response, requireList: evidenceConfig?.requireList })
    }
  }, [evidences])

  const shouldShowSchedulingButton = scheduledVisitId || modelId;

  const handleSchedulingClick = () => {
  if (model === 'assignedQuestionnaire') {
    const backPath = `/dashboard/calendar/detail/${scheduledVisitId ?? modelId}`;
    navigate(backPath, {
      state: {
        assignedQuestionnaireId: modelId,
        activityName: title
      }
    });
  } else if (model === 'userQuestionnaire') {
    const backPath = `/dashboard/schedule-user/detail/${scheduledVisitId ?? modelId}`;
    navigate(backPath, {
      state: {
        assignedQuestionnaireId: modelId,
        activityName: title
      }
    });
  }
};



  return (
    <>
      <CustomPaper elevation={2} sx={styles.paper}>
        <Box sx={styles.headerPaper}>
          <Box sx={styles.leftHeader}>
            <Typography variant="text_grey" fontWeight='bold'># {position}</Typography>
            <Typography variant="text_grey" fontWeight='500'>{getType(typeActivity ?? ActivityType.PROGRAMMED, t).toUpperCase()}</Typography>
          </Box>

          <Box sx={styles.headerButons}>
            <Box sx={styles.scheduling}>
              {shouldShowSchedulingButton && (
                <Button variant="text" onClick={handleSchedulingClick} sx={styles.schedulingBtn}>
                  {t('general.scheduling')}
                </Button>
              )}
            </Box>

            {!!showComponent && (
              <DetailAndUploadOfEvidences
                Node={({ payload: { openDrawer } }) => (
                  <CustomeIconButton
                    title={view == ViewEvidence.DETAIL ? t('general.seeEvidence') : t('loogbook.titles.chargeEvidence')}
                    icon={icons('clip')}
                    iconButtonProps={{
                      sx: { color: colors.contrastEndpoint },
                      onClick: () => {
                        setDeletedsEvidencesList([])
                        openDrawer()
                        validateCanUpload()
                      }
                    }}
                  />
                )}
                view={view}
                save={() => submitEvidences({ evidences: evidencesDrawer })}
                detail={{ evidences: { image: evidences?.images, comment: evidences?.comments, documents: evidences?.documents, video: evidences?.video, sign: evidences?.sign }, existEvidences }}
                upload={{
                  evidencesDrawer,
                  evidencesRequiredAreLoad,
                  deletedEvidence: ({ name }) => { setDeletedsEvidencesList(prev => [...prev, name]) },
                  fakeDelete: false,
                  close: () => {},
                  showRequireds: evidenceUpload.showRequireds,
                  setEvidencesDrawer,
                  setEvidencesRequiredAreLoad,
                  uploadName: `logbook/${id}`,
                }}
                disable={disable}
                downloadEvidences={downloadEvidences}
              />
            )}

            <CustomeIconButton
              title={t(`general.${isVisible ? 'hiddenUser' : 'showUser'}`)}
              icon={icons(isVisible ? 'visibility' : 'visibility-off')}
              iconButtonProps={visibility}
            />

            <Settings
              icon="moreVert"
              menu={{
                menuItems: menu,
                click: (menu) => menuOption(menu, { id, geofence, initDate: startDateJs, storePoint, someIsRequired, timeZone, endDate: endDateJs })
              }}
            />
          </Box>
        </Box>

        <CustomAccordion
          title={
            <Box sx={styles.acordionTitleContainerArrow(expandParent)}>
              <Tooltip title={t(`ToolTips.${expandParent ? 'collapse' : 'expand'}`)}>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleExpand(id, !expandParent);
                  }}
                  sx={[styles.arrow, styles.rotate(expandParent)]}
                >
                  {icons('arrow-down')}
                </IconButton>
              </Tooltip>
              <Box sx={styles.acordionTitleContainer}>
                <Typography variant="text_grey" fontWeight='bold' fontSize={16}>{title ?? ''}</Typography>
                <Box sx={styles.acordionTitleDescription}>
                  <CaptionKeyVertical caption={`${t('general.assignedBy')}: `} value={assignedBy || 'N/A'} />
                  <StatusComponent color={isNoFinisf ? colorNoFinish : statusDetail.color} msg={statusDetail.text} type="chip" size="xs" fit />
                </Box>
              </Box>
            </Box>
          }
          description={
            <ActivityDetailList
              closeMotive={closeMotive}
              endDate={endDate}
              endExecution={endExecution}
              initDate={initDate}
              startExecution={startExecution}
              storeAndId={storeAndId}
              type={type}
              unityLocation={unityLocation}
              finishLocation={finishLocation}
              initLocation={initLocation}
              isForcedClosure={isForcedClosure}
              evidences={evidences}
              existEvidences={existEvidences}
            />
          }
          expandIcon={null}
          expanded={expandParent}
        />
      </CustomPaper>

      <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />
    </>
  );
}
